import { Menu, MenuItem } from "@material-ui/core";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ShareIcon from "@material-ui/icons/Share";
import { MoodboardTilesContext } from "../N";

import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

import "./ItemBar.scss";
import MoveToModal from "../MoveToModal/MoveToModal";
import axios from "axios";
import { Dropdown, Menu as MenuAntd } from "antd";
import styled from "styled-components";
import projectService from "../../services/project";
import moodboardService from "../../services/moodboard";
import { swalSuccess, swalError } from "../../utils/swal";

const ItemBar = forwardRef(
  (
    {
      children,
      deleteItem,
      viewItem,
      currentFile,
      rateAsset,
      rateAssetService,
    },
    ref
  ) => {
    const modalRef = useRef();
    const [anchorEl, setAnchorEl] = useState(null);
    const [isUrlCORS, setIsUrlCORS] = useState(false);
    const [visibleColor, setVisibleColor] = useState(false);
    const [commentCount, setCommentCount] = useState(99);
    const [showAddToProject, setShowAddToProject] = useState(false);
    const [userProjects, setUserProjects] = useState([]);
    const [addingAsset, setAddingAsset] = useState(false);

    const { onCopy, onShare, onThumbnailChange } = useContext(
      MoodboardTilesContext
    );
    const thumbnailInputRef = useRef();
    const [uploadingThumbnail, setUploadingThumbnail] = useState(false);

    // Uploaded videos have no poster of their own, so they render as a blank
    // black tile. Let the user attach any image as the thumbnail.
    const isVideo =
      currentFile?.type === "video" || currentFile?.type === "pexels-video";

    const onPickThumbnail = async (e) => {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!file) return;

      setUploadingThumbnail(true);
      const result = await moodboardService.setCustomThumbnail(
        currentFile._id,
        file
      );
      setUploadingThumbnail(false);

      if (result.error) {
        swalError(result.error);
        return;
      }
      swalSuccess("Thumbnail updated");
      if (onThumbnailChange) onThumbnailChange();
    };

    const onRemoveThumbnail = async () => {
      setUploadingThumbnail(true);
      const result = await moodboardService.resetThumbnail(currentFile._id);
      setUploadingThumbnail(false);

      if (result.error) {
        swalError(result.error);
        return;
      }
      swalSuccess("Custom thumbnail removed");
      if (onThumbnailChange) onThumbnailChange();
    };

    const open = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    useImperativeHandle(ref, () => ({
      closeMenu: () => {
        handleClose();
      },
    }));


    useEffect(() => {
      console.log(currentFile?._id)

      //New What do I put here to SetCommentCount
     
      // Check if image url is not CORS, then allow to edit
      const validateFileUrl = async () => {
        try {
          await axios.get(currentFile.fileUrl);
        } catch (e) {
          setIsUrlCORS(true);
        }
      };
      if (currentFile.type === "image") {
        validateFileUrl();
      }
    }, []);

    const colors = ["#47E084", "#E0DA47", "#E0475F", "#F3F3F3"];

    const colorMenu = (
      <div
        style={{
          width: "fit-content",
          padding: "12px",
          display: "flex",
          alignItems: "center",
          gap: "16px",
          backgroundColor: "#2c2c2c",
          borderRadius: "4px",
        }}
      >
        {colors.map((color) => (
          <div
            key={color}
            onClick={() => {
              setVisibleColor(false);
              rateAssetService(currentFile?._id, color);
            }}
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              border: `2px solid ${color}`,
              cursor: "pointer",
            }}
          />
        ))}
      </div>
    );

    const selectColor = (
      <Dropdown
        defaultValue=""
        trigger={["click"]}
        overlay={colorMenu}
        visible={visibleColor}
        onVisibleChange={setVisibleColor}
      >
        <div
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            border: `2px solid ${currentFile.color || "#F3F3F3"}`,
          }}
        />
      </Dropdown>
    );

    return (
      <Wrapper>
        <div className="tile-options">
          {/* Check if comments > 0, then show commentsIcon */}
         {currentFile?.numOfComments > 0 && (<IconButton
            onClick={(e) => {
              setAnchorEl(null);
              viewItem();
            }}
          >
            <Badge badgeContent={currentFile?.numOfComments} color="error">
              <ChatBubbleIcon
                fontSize="small"
                sx={{ color: "white" }}
              ></ChatBubbleIcon>
            </Badge>
          </IconButton>)} 
          {selectColor}
          <MoreHorizIcon onClick={handleClick} />
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
          >
            {!isUrlCORS && children}
            {/* <MenuItem
            onClick={(e) => {
              setAnchorEl(null);
              modalRef.current.openModal();
            }}
          >
            Move to
          </MenuItem> */}
            {isVideo && (
              <MenuItem
                disabled={uploadingThumbnail}
                onClick={(e) => {
                  setAnchorEl(null);
                  thumbnailInputRef.current.click();
                }}
              >
                {currentFile?.hasCustomThumbnail
                  ? "Change Custom Thumbnail"
                  : "Add Custom Thumbnail"}
              </MenuItem>
            )}
            {isVideo && currentFile?.hasCustomThumbnail && (
              <MenuItem
                disabled={uploadingThumbnail}
                onClick={(e) => {
                  setAnchorEl(null);
                  onRemoveThumbnail();
                }}
              >
                Remove Custom Thumbnail
              </MenuItem>
            )}
            <MenuItem
              onClick={(e) => {
                setAnchorEl(null);
                viewItem();
              }}
            >
              View Comments
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                setAnchorEl(null);
                deleteItem();
              }}
            >
              Delete
            </MenuItem>
            <MenuItem
              onClick={async (e) => {
                setShowAddToProject(!showAddToProject);
                if (userProjects.length === 0) {
                  const result = await projectService.getAll("", []);
                  if (result.data) setUserProjects(result.data);
                }
              }}
            >
              Add to Project
            </MenuItem>
            {showAddToProject && (
              <div style={{
                maxHeight: "200px",
                overflowY: "auto",
                borderTop: "1px solid #333",
                padding: "4px 0",
              }}>
                {userProjects.map((p) => (
                  <MenuItem
                    key={p._id}
                    disabled={addingAsset}
                    onClick={async () => {
                      setAddingAsset(true);
                      const result = await moodboardService.copyAsset(
                        currentFile._id,
                        p._id
                      );
                      if (result.data) {
                        swalSuccess("Asset added to project");
                      } else {
                        swalError(result.error || "Failed to add asset");
                      }
                      setAddingAsset(false);
                      setShowAddToProject(false);
                      setAnchorEl(null);
                    }}
                    style={{ fontSize: "13px", paddingLeft: "24px" }}
                  >
                    {p.title || "Untitled"}
                  </MenuItem>
                ))}
              </div>
            )}
          </Menu>
          <MoveToModal
            ref={modalRef}
            onCopy={onCopy}
            listAssets={[currentFile]}
          />
        </div>
        <input
          ref={thumbnailInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={onPickThumbnail}
        />
        {onShare && (
          <button
            type="button"
            className="tile-share-btn"
            title="Share project"
            onClick={(e) => {
              e.stopPropagation();
              onShare();
            }}
          >
            <ShareIcon style={{ fontSize: "16px" }} />
          </button>
        )}
      </Wrapper>
    );
  }
);

export default ItemBar;

const Wrapper = styled.div`
  .ant-select-selector {
    background: none !important;
    border: none !important;
    padding: 0 !important;
    height: 16px !important;
  }
`;
